import { useTranslation } from "react-i18next";
import { useCompany } from "../store/hooks";
import Layout from "./common/Layout";
import PurchasersInvitation from "./PurchasersInvitation";
import { useState } from "react";
import Toast from "./common/Toast";
import Back from "./common/Back";

const Success = () => {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [showInvitationSentSuccess, setShowInvitationSentSuccess] =
    useState(false);
  const [invitees, setInvitees] = useState([
    { firstName: "", lastName: "", email: "" },
  ]);
  const company = useCompany();
  const { t } = useTranslation();

  const companyName = company?.name || t("successPage.companyFallback");

  const handleInviteSuccess = () => {
    setIsInviteModalOpen(false);
    setShowInvitationSentSuccess(true);
    setInvitees([{ firstName: "", lastName: "", email: "" }]);
  };

  const handleInviteTeamClick = () => {
    setIsInviteModalOpen(true);
    setShowInvitationSentSuccess(false);
  };

  return (
    <Layout>
      <div className="result-page-container success-page-container">
        <div className="result-header">
          <div className="mb-3">
            <img
              src={process.env.PUBLIC_URL + "/images/success-icon.svg"}
              alt="Success Icon"
              className="result-icon"
            />
          </div>
          <h1 className="success-page-title">{t("successPage.title")}</h1>
        </div>

        <div className="result-content mt-2">
          <p className="result-page-message">{t("successPage.messageReady")}</p>
          <p className="result-page-message">
            {t("successPage.messageInstruction")}
          </p>
        </div>

        <button
          type="button"
          className="az-btn mt-4 success-primary-btn text-uppercase"
          onClick={handleInviteTeamClick}
        >
          {t("successPage.inviteTeam")}
        </button>
      </div>

      {showInvitationSentSuccess && (
        <Toast text={t("successPage.invitation.success")} isError={false} />
      )}

      <Back message={t("back.label")} />
      <PurchasersInvitation
        isOpen={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
        onSuccess={handleInviteSuccess}
        invitees={invitees}
        setInvitees={setInvitees}
        companyName={companyName}
      />
    </Layout>
  );
};

export default Success;
